import type { PermissaoChave } from '@/shared/permissoes/chaves';

/**
 * Lê SÓ o `permissoes[]` que veio do `GET /v1/me` (F2-4).
 *
 * Sem fallback por prefixo e sem olhar `papel` no cliente — de propósito. O
 * servidor já expande o catálogo inteiro para o super_admin, então qualquer
 * regra extra aqui seria uma segunda fonte de verdade, e a divergência entre as
 * duas é o bug que ninguém encontra.
 *
 * E lembre: permissão no front é UX. A defesa é o 403 do servidor.
 */
export function hasPermission(
  concedidas: readonly string[] | undefined,
  exigida: PermissaoChave,
): boolean {
  if (!concedidas) return false;
  return concedidas.includes(exigida);
}

/** Verdadeiro se o usuário tiver ao menos uma das permissões. */
export function hasAnyPermission(
  concedidas: readonly string[] | undefined,
  exigidas: readonly PermissaoChave[],
): boolean {
  if (!concedidas || exigidas.length === 0) return false;
  return exigidas.some((chave) => concedidas.includes(chave));
}
